import {
  Box,
  Grid,
  Divider,
  Paper,
  Typography,
  makeStyles
} from '@material-ui/core'
import React from 'react'
import SolicitacaoCard from '../SolicitacaoCard'

import ResumoClassificacao from './ResumoClassificacao'

const useStyles = makeStyles({
  container: {
    '@media print': {
      display: 'block'
    }
  }
})

const ClassificacaoRelatorio = ({
  classificacao,
  printingRef,
  match,
  entityManager
}) => {
  const classes = useStyles()
  if (!classificacao) return null

  let composicao = []
  let proprietarioCavalo = {}
  const veiculos = entityManager.item.veiculos ?? []

  if (veiculos.length > 0) {
    composicao = entityManager.item.veiculos.map(v => v.placa)
    proprietarioCavalo = veiculos[0].proprietario
  }

  return (
    <Box style={{ display: 'none' }}>
      <Box ref={printingRef} className={classes.container}>
        <Box className="no-break">
          <SolicitacaoCard
            match={match}
            empresa={entityManager.item?.empresa?.sigla}
            nomeMotorista={entityManager.item?.motorista?.nome}
            cpfMotorista={entityManager.item?.motorista?.cpf}
            nomeEmbarcador={entityManager.item?.nomeEmbarcador}
            nomeProprietario={proprietarioCavalo?.nomeRazaoSocial}
            cpfCnpjProprietario={proprietarioCavalo?.cpfcnpj}
            centroCusto={entityManager.item?.centroCusto}
            composicao={composicao}
            mercadoria={entityManager.item?.mercadoria?.descricao}
            cliente={entityManager.item?.cliente}
            valorCarga={entityManager.item?.valorCarga}
            dataTermino={entityManager.item?.dataTermino}
            status={entityManager.item?.status}
            isPrinting
          />
        </Box>

        {classificacao.topicos.map(topico => {
          return (
            <Box pt={2} key={topico.titulo} className="no-break">
              <Paper>
                <Box p={2}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Typography variant="h6">
                        <Box fontWeight="fontWeightBold">{topico.titulo}</Box>
                      </Typography>
                    </Grid>
                    {topico.itens.map((item, itemIndex) => {
                      const renderDivider = itemIndex < topico.itens.length - 1

                      return (
                        <Grid item xs={12} key={`${item.titulo}-${itemIndex}`}>
                          <Grid container spacing={2}>
                            <Grid item xs={12}>
                              <ResumoClassificacao
                                titulo={item.titulo}
                                src={item.src}
                                itens={item.status}
                                nota={item.nota}
                                isPrinting
                              />
                            </Grid>
                            {renderDivider && (
                              <Grid item xs={12}>
                                <Divider />
                              </Grid>
                            )}
                          </Grid>
                        </Grid>
                      )
                    })}
                  </Grid>
                </Box>
              </Paper>
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}

export default ClassificacaoRelatorio
